import { AutogenModelDrsPayee, AutogenRowDrsPayee } from "./autogen/AutogenModelDrsPayee";

export class ModelDrsPayee extends AutogenModelDrsPayee<RowDrsPayee> {
	constructor() {
		super(RowDrsPayee);
	}
}

export class RowDrsPayee extends AutogenRowDrsPayee {
}
